import { render, staticRenderFns } from "./huankuanTable.vue?vue&type=template&id=2fc2b4e2"
import script from "./huankuanTable.vue?vue&type=script&lang=js"
export * from "./huankuanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc2b4e2')) {
      api.createRecord('2fc2b4e2', component.options)
    } else {
      api.reload('2fc2b4e2', component.options)
    }
    module.hot.accept("./huankuanTable.vue?vue&type=template&id=2fc2b4e2", function () {
      api.rerender('2fc2b4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widget/huankuanTable.vue"
export default component.exports